<template>    
  <MainAppView></MainAppView>
  <Toast></Toast>
  <ConfirmDialog></ConfirmDialog>    
  <DynamicDialog />   
</template>
<script setup lang="ts">
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import DynamicDialog from 'primevue/dynamicdialog';
import MainAppView from './views/MainAppView.vue';
import { useServicesFactoryStore } from '@/core/stores/services-factory-store';
import AppUIManagerService from '@/core/services/AppUIManagerService';
import { traduceTexto } from './core/services/base/GlobalFunctios';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePrimeVue } from 'primevue/config';
import moment from 'moment';
import jsonLangEsDefault from '@/locales/es.json';
import jsonLangEnDefault from '@/locales/en.json'; 
import LoginService from './core/services/login/LoginService';
import { IAppUserSettings } from './core/services/sys/AppSystemSettingsService';
import { useMainStore } from './core/stores/main-store';
import { eThemesNames } from './core/model/GloblasEnum';

const currentLang = useI18n();
const primevue = usePrimeVue();
const mainStore = useMainStore();
const loginServie:LoginService = useServicesFactoryStore().getLoginService;
const uiManager:AppUIManagerService = useServicesFactoryStore().getAppUIManagerService;
uiManager.setGlobalLabel('espere',traduceTexto('globals.espere'));
uiManager.setGlobalLabel('cancel',traduceTexto('globals.cancel'));
uiManager.setGlobalLabel('aceptar',traduceTexto('globals.aceptar'));
uiManager.setGlobalLabel('appOptionsComponent',traduceTexto('globals.appOptionsComponent'));
const changeLanguage = (idioma:any)=>
{  
  //$i18n.locale = idioma.id;
  //https://vue-i18n.intlify.dev/guide/essentials/scope.html  
  currentLang.locale.value = idioma;
  moment.locale(idioma);  
  switch(idioma)
  {
    case 'es-mx':
      primevue.config.locale = {...jsonLangEsDefault.prime};
      break;
    case 'en-us': 
      primevue.config.locale = {...jsonLangEnDefault.prime};
      break;
  }  
}
const changeTheme= (theme:string) => 
{
  const themeData = theme.split('_')[0].toLowerCase();  
  if (!themeData || themeData === "light")
  {
    document.documentElement.setAttribute('data-theme', '');
    primevue.changeTheme('lara-dark-blue','lara-light-blue', 'site-theme-link');    
  }
  else
  {
    document.documentElement.setAttribute('data-theme', eThemesNames.dark);
    primevue.changeTheme('lara-light-blue','lara-dark-blue', 'site-theme-link');
  }  
}
onMounted(async ()=>
{        
  const appSettings:IAppUserSettings = await loginServie.getAppSettings();  
  changeLanguage(appSettings.language);
  changeTheme(appSettings.theme);
  mainStore.setAppLanguage(appSettings.language);
});
</script>

